var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isPublic
      ? _c(
          "a",
          {
            class: [
              "theme-btn theme-btn--primary my-4",
              _vm.pushButtonDisabled || _vm.loading
                ? "theme-btn--primary-disabled"
                : ""
            ],
            attrs: {
              href: "javascript:void(0);",
              title: _vm.pushButtonDisabled || _vm.loading ? "Disabled" : ""
            },
            on: { click: _vm.togglePush }
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v(
                _vm._s(
                  _vm.isPushEnabled
                    ? "notifications_off"
                    : "notifications_active"
                )
              )
            ]),
            _vm._v(" "),
            _c("span", {}, [
              _vm._v(
                _vm._s(_vm.isPushEnabled ? "Disable" : "Enable") +
                  " Push Notifications"
              )
            ])
          ]
        )
      : _c(
          "button",
          {
            class: [
              "theme-btn theme-btn--primary mt-4",
              _vm.pushButtonDisabled || _vm.loading
                ? "theme-btn--primary-disabled"
                : ""
            ],
            attrs: {
              title: _vm.pushButtonDisabled || _vm.loading ? "Disabled" : "",
              disabled: _vm.pushButtonDisabled || _vm.loading
            },
            on: { click: _vm.togglePush }
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v(
                _vm._s(
                  _vm.isPushEnabled
                    ? "notifications_off"
                    : "notifications_active"
                )
              )
            ]),
            _vm._v(" "),
            _c("span", {}, [
              _vm._v(
                _vm._s(_vm.isPushEnabled ? "Disable" : "Enable") +
                  " Push Notifications"
              )
            ])
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60ffb726", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ffb726","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/NotificationsSubscribe.vue
// module id = 342
// module chunks = 1 2